import type { CustomerPortalSaveRetailPricesMutation } from "~/gql/mutations/portalRetailPrices.generated";
import type {
	CustomerPortalRetailPriceRowResultFieldsFragment,
	CustomerPortalRetailPriceSaveFieldsFragment
} from "~/gql/queries/portalRetailPrices.generated";
import type { MutationRawResult } from "~/helpers/runMutation";
import type { RetailPriceRowError } from "~portal/catalog/helpers/retailPriceDraft";

import { BackgroundJobStatus } from "~/gql/graphqlBase.generated";

export const RETAIL_PRICE_SAVE_POLL_MS = 2000;

export const RETAIL_PRICE_SAVE_STALL_MS = 180_000;

export const RETAIL_PRICE_SAVE_ROWS_PAGE_SIZE = 100;

export type RetailPriceSaveSubmission =
	| { errors: RetailPriceRowError[]; invalidRows: CustomerPortalRetailPriceRowResultFieldsFragment[]; kind: "refused" }
	| { kind: "stored"; save: CustomerPortalRetailPriceSaveFieldsFragment }
	| { kind: "uncertain" };

const OPEN_STATUSES: readonly BackgroundJobStatus[] = [
	BackgroundJobStatus.Queued,
	BackgroundJobStatus.Pending,
	BackgroundJobStatus.Running
];

const isOpenStatus = (status: BackgroundJobStatus): boolean => OPEN_STATUSES.includes(status);

const progressSignature = (save: CustomerPortalRetailPriceSaveFieldsFragment): string =>
	[save.status, save.done, save.failed, save.updatedAt].join("|");

const classifySubmission = (
	raw: MutationRawResult<CustomerPortalSaveRetailPricesMutation>
): RetailPriceSaveSubmission => {
	const payload = raw.data?.customerPortalSaveRetailPrices;
	if (raw.transportError || !payload) return { kind: "uncertain" };
	if (payload.save) return { kind: "stored", save: payload.save };
	if (payload.errors?.length) return { errors: payload.errors, invalidRows: payload.invalidRows, kind: "refused" };
	return { kind: "uncertain" };
};

const retailPriceSave = {
	classifySubmission,
	isOpenStatus,
	progressSignature
};

export default retailPriceSave;
